// List of category options for courses
export const CATEGORY_OPTIONS = [
  { value: "waste", label: "Waste Management" },
  { value: "development", label: "Energy and Climate" },
  { value: "marine", label: "Marine Science" },
  { value: "geospatial", label: "Geospatial Technology" },
  { value: "geology", label: "Geology" },
  { value: "research", label: "Research" },
];